<template>
    <page-table/>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-evgSalesPlatform',
  components: {
    PageTable,
  },
}
</script>